<template lang="html">
  <div class="admin-sugestions-wrapper">
    <div class="title">
      Sugestije
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>vreme</td>
            <td>Ime i prezime</td>
            <td>email</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sugestion) in sugestions" :key="sugestion.msg_id">
            <td>
              {{sugestion.msg_date}}
            </td>
            <td>
              {{sugestion.usr_name}}
            </td>
            <td>
              {{sugestion.usr_email}}
            </td>
            <td>
              <div @click="open(sugestion)" class="btn">
                otvori
              </div>
            </td>
            <td>
              <div @click="openConfirmationModal(sugestion)" class="btn">
                obriši
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="sugestions.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminSugestions',
  components: {
    Paginate
  },
  data () {
    return {
      sugestions: [],
      page: 1,
      pageCount: 0
    }
  },
  mounted () {
    this.getSugestions()
  },
  methods: {
    getSugestions () {
      let params = {
        page: this.page
      }
      api.getSugestions(params).then(res => {
        this.sugestions = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    open (sugestion) {
      let modalData = {
        title: 'Informacije o sugestiji:',
        info: this.generateInfoObject(sugestion)
      }
      let params = {
        modalData: modalData,
        component: 'singleSugestion'
      }
      eventBus.$emit('openModal', params)
    },
    generateInfoObject (sugestion) {
      let info = [
        { key: 'Vreme', value: sugestion.msg_date },
        { key: 'Ime i prezime', value: sugestion.usr_name },
        { key: 'Email', value: sugestion.usr_email },
        { key: 'Sugestija', value: sugestion.msg_message }
      ]
      return info
    },
    openConfirmationModal (sugestion) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovu sugestiju',
        ok: () => {
          this.deleteSugestion(sugestion)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteSugestion (sugestion) {
      let params = {
        id: sugestion.msg_id
      }
      api.deleteSugestion(params).then(res => {
        this.getSugestions()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.getSugestions()
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-sugestions-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
}
</style>
